/* eslint-disable react-hooks/exhaustive-deps */
import { tokens } from "../../../../theme";
import { Paper, Box, Typography, useTheme } from "@mui/material";
import DataGridButton from "../../../../components/DataGridButton";
import { dataGridButtonTypography } from "../../../../styles/DataGridStyles";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { DB_PATCH_REPO_NAME } from "../../../../utils/constants";
import { githubUrl, simUrl } from "../../../../utils/urls";
import useIamModal from "../../../IamModal/UseIamModal";
import { buildDetailedPanelStyles } from "../../styles";
import StepBox from "./StepBox";

const DetailPanelContent = ({
  row,
  showRetryDialog,
  retryPermissionList,
  setReportModalOpen,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const { IamModal, IamButton } = useIamModal(
    `/apps/tessell/software-images/db-software/builds/${row?.id}`,
    [],
    buildDetailedPanelStyles.otherDetailsButton
  );

  return (
    <Grid
      container
      sx={buildDetailedPanelStyles.mainGrid}
      justifyContent={"space-around"}
    >
      {IamModal}
      <Grid xs={6} lg={6}>
        <Paper elevation={4} sx={buildDetailedPanelStyles.paper}>
          <Typography variant="h4">Steps:</Typography>
          {row?.runData?.steps?.map((step, index) => (
            <StepBox
              step={step}
              showRetryDialog={showRetryDialog}
              id={row?.id}
              retryPermissionList={retryPermissionList}
            />
          ))}
        </Paper>
      </Grid>
      <Grid xs={6} lg={6}>
        <Paper elevation={4} sx={buildDetailedPanelStyles.paper}>
          <Typography variant="h5">
            Old Version Name: {row?.inputData?.oldVersionName}
          </Typography>
          <Box sx={buildDetailedPanelStyles.otherDetailsHorizontalBox}>
            {row?.runData?.steps?.filter((step) => {
              if (step.stepName === "commit-in-github") {
                return step.status === "COMPLETED";
              }
              return false;
            }).length > 0 ? (
              <DataGridButton
                sx={buildDetailedPanelStyles.otherDetailsButton}
                onClick={() =>
                  window.open(
                    `${githubUrl}/${DB_PATCH_REPO_NAME}/compare/${row?.inputData?.releaseBranch}...${row?.jiraId}_convoy_os_image_patch_automation?expand=1`
                  )
                }
              >
                <Typography sx={dataGridButtonTypography(colors, 500)}>
                  Create PR
                </Typography>
              </DataGridButton>
            ) : (
              <></>
            )}

            {IamButton}
          </Box>
          {Object.keys(row?.inputData?.clouds)?.map((cloud) => (
            <Box sx={buildDetailedPanelStyles.otherDetailsHorizontalBox}>
              <Typography
                variant="h5"
                sx={
                  buildDetailedPanelStyles.osImageOtherDetialsItemKeyTypography
                }
              >
                {cloud}
              </Typography>
              <Box sx={buildDetailedPanelStyles.scriptPathBox}>
                <Typography variant="h6">
                  {row?.inputData?.clouds?.[cloud]?.tenantDomain}
                </Typography>
              </Box>
              {row?.runData?.steps?.filter((step) => {
                if (step.stepName === "trigger-qa" && step?.cloud === cloud) {
                  return step.status === "COMPLETED" || true;
                }
                return false;
              }).length > 0 ? (
                <DataGridButton
                  sx={buildDetailedPanelStyles.osImageQaButton}
                  onClick={() =>
                    setReportModalOpen(
                      `${simUrl}/apps/tessell/software-images/os/builds/${row?.id}/qa-automation-report?cloud=${cloud}`
                    )
                  }
                >
                  <Typography sx={dataGridButtonTypography(colors, 500)}>
                    QA Report
                  </Typography>
                </DataGridButton>
              ) : (
                <></>
              )}
            </Box>
          ))}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default DetailPanelContent;
